<div class="toasts row">
    <div *ngFor="let toast of toasts" [ngClass]="toast.type" class="toast bg_color_black color_white">
        <button (click)="closeToast(toast.id)" type="button" class="btn_close">
            <span class="icon-close"></span>
        </button>
        <div class="row toast_container row_ai_center">
            <div class="icon_area row row_ai_center row_jc_center">
                <span [ngClass]="toast.icon" class="icon"></span>
            </div>
            <div class="message">
                <p class="title fz_m fw_500">{{ toast.title }}</p>
                <p class="text fz_s">{{ toast.message }}</p>
            </div>
        </div>
        <div class="progress-bar">
            <div class="progress" [style.width.%]="toast.progress"></div>
        </div>
    </div>
</div>